import { GetServerSideProps } from 'next'
import { GlobalRequest } from '~/components/global-requset'
import { MyContainer } from '~/components/ui/MyContainer'
import MyTabs from '~/components/ui/MyTabs'
import { GET_GENERATOR_TAGS } from '~/graphqls/gqls'
import {
  getGeneratorTags,
  getGeneratorTags_aiArtworkResourceModule_spellTab,
  getGeneratorTags_aiArtworkResourceModule_spellTab_tags,
} from '~/graphqls/types'
import { Layout } from '~/layouts/default'
import { SEOHead } from '~/components/business/SEOHead'

import styles from './index.module.css'
import { useEffect, useState, useMemo } from 'react'
import { useRouter } from 'next/router'
import classNames from 'classnames'
import { MySwitch } from '~/components/ui/MySwitch'
import { TagList } from '~/components/pages/tag/TagList'
import { TagTab } from '~/components/pages/tag/TagTab'

const tabsData = [
  {
    id: '/tag-generator',
    name: '咒语生成器',
    type: 'generator',
  },
  {
    id: '/tag-generator/tags',
    name: 'Tag大全',
    type: 'list',
  },
]

export const enum SymbolTypes {
  /** 大括号 */
  BRACE = 'BRACE',
  /** 小括号 */
  CURVE = 'CURVE',
}

interface TagsTypes
  extends getGeneratorTags_aiArtworkResourceModule_spellTab_tags {
  weight: number
}

const Generator = ({
  tagsData,
}: {
  tagsData: getGeneratorTags_aiArtworkResourceModule_spellTab[]
}) => {
  const router = useRouter()
  const [englishVisible, setEnglishVisible] = useState(true)
  const [selectSymbol, setSelectSymbol] = useState(SymbolTypes.CURVE)

  const [selectList, setSelectList] = useState<TagsTypes[]>([])

  const onTabsChange = (item: any) => {
    if (item.id !== router.pathname) {
      router.push(item.id)
    }
  }

  return (
    <Layout>
      <SEOHead title="咒语生成器" />
      <MyContainer>
        <div className="flex justify-between items-stretch pb-6">
          <div className="w-[1078px]">
            <div className="flex justify-between items-center h-8 mb-4">
              <MyTabs
                className={classNames('text-base', styles.myTabs)}
                items={tabsData}
                onChange={onTabsChange}
                active={tabsData.filter(it => it.type === 'generator')?.[0]?.id}
              />
              <div className="flex justify-start items-center">
                <div className="flex items-center mr-3">
                  <span className="mr-1.5 text-neutral-400 text-xs">
                    English
                  </span>
                  <MySwitch
                    size="small"
                    checked={englishVisible}
                    onChange={checked => {
                      setEnglishVisible(checked)
                    }}
                  />
                </div>
                <div className="flex items-center">
                  <span className="mr-1.5 text-neutral-400 text-xs">加权</span>
                  <div className="p-[2px] rounded bg-neutral-200 flex items-center text-xs leading-4 text-center cursor-pointer">
                    <div
                      className={classNames(
                        'w-6 h-4 rounded-sm leading-[14px]',
                        {
                          'bg-primary text-neutral-800':
                            selectSymbol === SymbolTypes.CURVE,
                        }
                      )}
                      onClick={() => setSelectSymbol(SymbolTypes.CURVE)}
                    >{`()`}</div>
                    <div
                      className={classNames(
                        'w-6 h-4 rounded-sm ml-1 leading-[14px]',
                        {
                          'bg-primary text-neutral-800':
                            selectSymbol === SymbolTypes.BRACE,
                        }
                      )}
                      onClick={() => setSelectSymbol(SymbolTypes.BRACE)}
                    >{`{}`}</div>
                  </div>
                </div>
              </div>
            </div>
            <TagTab
              tagsData={tagsData}
              englishVisible={englishVisible}
              selectList={selectList}
              setSelectList={setSelectList}
            />
          </div>
          <div className="flex-1 ml-6">
            <TagList
              selectList={selectList}
              setSelectList={setSelectList}
              selectSymbol={selectSymbol}
              tagsData={tagsData}
            />
          </div>
        </div>
      </MyContainer>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState, client } = await GlobalRequest(context)
  const res = await client.query<getGeneratorTags>({
    query: GET_GENERATOR_TAGS,
    variables: {},
    fetchPolicy: 'no-cache',
  })
  return {
    props: {
      initialState,
      tagsData: res?.data?.aiArtworkResourceModule?.spellTab || [],
    },
  }
}

export default Generator
